import { useQuery } from '@tanstack/react-query';
import { getBillingReconciliationOptimizationSettings } from './billingReconciliationSettingsApi.js';

export const billingReconSettingsKeys = {
  optimization: () => ['billingRecon', 'settings', 'optimization'],
};

export const useBillingReconciliationOptimizationSettings = (options = {}) =>
  useQuery({
    queryKey: billingReconSettingsKeys.optimization(),
    queryFn: ({ signal }) => getBillingReconciliationOptimizationSettings({ signal }),
    staleTime: 30 * 1000,
    refetchInterval: 30 * 1000,
    retry: false,
    ...options,
  });
